import { Grid, Group } from "@mantine/core"
import { OperationsAdminVenueBookingTabs } from "src/components/operations/administrator/bookings/OperationsAdminVenueBookingTabs"
import { EditOperationsAdminVenueBookingAction } from "src/components/operations/administrator/bookings/OperationsAdminVenueBookingActions"
import { useAppState } from "src/state"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { formatDate, formatTime } from "src/utils/dates"
import { OperationsAdminVenueBookingView } from "src/components/operations/administrator/bookings/OperationsAdminVenueBookingView"
import BookingStatusMachine from "src/components/bookings/BookingStatusMachine"
import { OperationsAdminVenueBookingGuidelineActions } from "src/components/operations/administrator/bookings/guidelines/OperationsAdminVenueBookingGuidelineActions"

export function OperationsAdminVenueBookingOverlay() {

    const { currentItem } = useAppState(state=>state.bookings)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.talent_id ? currentItem.talent?.dj_display : 'Unassigned'} @ ${currentItem?.venue?.name}, ${formatDate(currentItem?.date, 'M/d')} ${!!currentItem?.set_start_time ? '- ' : ''}${formatTime(currentItem?.set_start_time)}`}
                    renderAction={
                        <Group gap="sm">
                            <EditOperationsAdminVenueBookingAction />
                        </Group>
                    }
                />
            }
        >
            <OperationsAdminVenueBookingTabs overlay={true} />

            <Grid>
                <Grid.Col span={{ base: 12, md: 4 }}>
                    <BookingStatusMachine
                        showStatusBadge={true}
                        showDescriptions={true}
                        buttonSize="xs"
                        spacing="md"
                    />
                    <OperationsAdminVenueBookingGuidelineActions />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 8 }}>
                    <OperationsAdminVenueBookingView />
                </Grid.Col>
            </Grid>

        </DrawerPageLayout>
    )

}